import React, { useState } from "react";
import styles from "./ChangePassword.module.css";
import { InputField, Modal, TextComponent } from "../../../../components";
import { PiSealCheck } from "react-icons/pi";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { IoCheckbox, IoSquareOutline } from "react-icons/io5";
import { validateForm, validatePassword } from "../../../../utills/Validators";
import {
  sessionExpired,
  showAlert,
} from "../../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { useDispatch } from "react-redux";
import { getUser, isLogin } from "../../../../Store/Actions/AuthAction";
const ChangePassword = ({ changePasswordModal, setChangePasswordModal }) => {
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [isLogout, setIslogout] = useState(false);
  const dispatch = useDispatch();
  const formState = [
    { key: "Old Password", value: password },
    { key: "New Password", value: newPassword },
    { key: "Confirm Password", value: confirmPass },
  ];

  const onChangePassword = () => {
    let userdata = {
      password,
      newPassword,
      confirmPass,
      logout: isLogout ? 1 : 0,
    };
    const validation = validateForm(formState);
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        })
      );
    } else if (!validatePassword(password)) {
      dispatch(
        showAlert({
          type: "warning",
          message:
            "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.",
        })
      );
      return;
    } else if (newPassword != confirmPass) {
      dispatch(
        showAlert({
          type: "warning",
          message: "Please make sure both passwords are identical.",
        })
      );
      return;
    } else {
      dispatch(AuthMiddleware.updatePassword(userdata))
        .then(() => {
          setPassword("");
          setConfirmPass("");
          setNewPassword("");
          setIsSuccessFulModal(true);
          setChangePasswordModal(false);
        })
        .catch(() => {});
    }

    // ✅ Proceed with actual sign-up logic
  };

  const onPressSuccessBtn = () => {
    if (isLogout) {
      localStorage.clear();
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      setIsSuccessFulModal(false);
    } else {
      setIsSuccessFulModal(false);
    }
  };
  return (
    <div className={styles.mainCont}>
      <Modal
        width={"600px"}
        open={changePasswordModal}
        onCancel={() => {
          setChangePasswordModal(false);
        }}
        twoButton
        okBtnTitle={"Create New Passsword"}
        cancelBtnTitle={"Go Back"}
        onClickCancelButton={() => {
          setChangePasswordModal(false);
        }}
        onClickOkButton={onChangePassword}
      >
        <div className={styles.edit_mainCont}>
          <div className={styles.edit_heading}>
            <TextComponent
              text={"Create Password"}
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--heading2-font-size)",
              }}
            />
            <TextComponent
              text={"Create a new strong password"}
              style={{ color: "var(--light-grey)" }}
            />
          </div>
          <InputField
            className={styles.input}
            label={"Old Password"}
            placeholder={"●●●●●●●●●●"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            rightIcon={
              passwordVisible ? (
                <LuEye size={20} color={"var(--input-icon)"} />
              ) : (
                <LuEyeOff size={20} color={"var(--input-icon)"} />
              )
            }
            onRightIconPress={() => setPasswordVisible(!passwordVisible)}
            type={passwordVisible ? "text" : "password"}
          />
          <InputField
            className={styles.input}
            label={"New Password"}
            placeholder={"●●●●●●●●●●"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            rightIcon={
              newPasswordVisible ? (
                <LuEye size={20} color={"var(--input-icon)"} />
              ) : (
                <LuEyeOff size={20} color={"var(--input-icon)"} />
              )
            }
            onRightIconPress={() => setNewPasswordVisible(!newPasswordVisible)}
            type={newPasswordVisible ? "text" : "password"}
          />
          <InputField
            className={styles.input}
            label={"Confirm New Password"}
            placeholder={"●●●●●●●●●●"}
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
            rightIcon={
              confirmPassVisible ? (
                <LuEye size={20} color={"var(--input-icon)"} />
              ) : (
                <LuEyeOff size={20} color={"var(--input-icon)"} />
              )
            }
            onRightIconPress={() => setConfirmPassVisible(!confirmPassVisible)}
            type={confirmPassVisible ? "text" : "password"}
          />
          <div
            className={styles.logoutCheck}
            onClick={() => setIslogout(!isLogout)}
          >
            {isLogout ? (
              <IoCheckbox color="var(--secondary-color)" />
            ) : (
              <IoSquareOutline />
            )}
            <TextComponent
              style={{ marginLeft: "5px" }}
              text={"Logout from all devices"}
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Password Changed Successfully!"}
        width={"400px"}
        buttonTitle={isLogout ? "Login to you Account" : "Ok"}
        onBtnPress={onPressSuccessBtn}
      ></Modal>
    </div>
  );
};

export default ChangePassword;
